import React from 'react';
import {Box, Divider, Stack} from '@mui/material';
import PropTypes from 'prop-types';

export const categoryColours = {
    Admissions: '#186BBE',
    'Application or Acceptance': '#0284c7',
    Boarding: '#9333ea',
    Blank: '#d0d0d0',
    Clubs: '#db2777',
    'In-Year': '#06b6d4',
    Inactive: '#94a3b8',
    Independent: '#7c3aed',
    Medical: '#dc2626',
    'New Starters': '#10b981',
    'New Student Record': '#14b8a6',
    Notification: '#f97316',
    Public: '#0891b2',
    'Self Service': '#0dad95',
    'Senior School Admissions': '#186BBE',
    'SEN and Welfare': '#FFEB3B',
    'Sixth Form': '#8b5cf6',
    Staff: '#A1887F',
    'Staff Forms related to Students': '#ea580c',
    'Student Admin': '#8b5cf6',
    'Trips and Activities': '#ea580c',
    'After-School Clubs': '#db2777',
    'School Template': '#2080C0',
    General: '#64748b',
};

export const getTemplateHeaderColour = ({
                                            category,
                                            parentCategory
                                        }) => (
    categoryColours[parentCategory] ||
    categoryColours[category] ||
    categoryColours.General
);

const FormTemplatePreviewVisual = ({
                                       category,
                                       parentCategory
                                   }) => {
    const headerColour = getTemplateHeaderColour({
        category,
        parentCategory
    });
    return (
        <Box
            sx={{
                width: '100%',
                height: 160,
                backgroundColor: headerColour,
                borderBottom: '1px solid #eee',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'center',
                pt: 4,
            }}
        >
            <Box
                sx={{
                    width: '65%',
                    height: '80%',
                    backgroundColor: '#fff',
                    borderTopLeftRadius: 6,
                    borderTopRightRadius: 6,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'stretch',
                    p: 2,
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        height: 8,
                        borderRadius: 2,
                        backgroundColor: '#64748b',
                        mb: 1.5,
                    }}
                />

                <Stack spacing={1}>
                    <Box sx={{
                        height: 14,
                        width: '90%',
                        backgroundColor: '#e5e7eb',
                        borderRadius: 1
                    }}/>
                    <Box sx={{
                        height: 14,
                        width: '80%',
                        backgroundColor: '#e5e7eb',
                        borderRadius: 1
                    }}/>
                    <Box sx={{
                        height: 14,
                        width: '95%',
                        backgroundColor: '#e5e7eb',
                        borderRadius: 1
                    }}/>

                    <Divider sx={{my: 1}}/>

                    <Box
                        sx={{
                            height: 28,
                            width: '40%',
                            backgroundColor: '#d1d5db',
                            borderRadius: 1,
                            alignSelf: 'flex-start',
                        }}
                    />
                </Stack>
            </Box>
        </Box>
    );
};

FormTemplatePreviewVisual.propTypes = {
    bgColour: PropTypes.string,
    category: PropTypes.string,
    parentCategory: PropTypes.string,
};

export default FormTemplatePreviewVisual;
